import { render } from "./Home.vue?vue&type=template&id=2d5aa6de&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2d5aa6de&scoped=true&lang=scss"

import exportComponent from "/home/nasu/nodejs/syakkinsoudan/ikeda-line/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5aa6de"]])

export default __exports__